import {  Flex, Form, Space, Table,  } from 'antd'
import React, { useEffect, useState } from 'react'
import classes from './report.module.css';   
import ReportEdit from './ReportEdit';
import Icon from '../../cpn/Icon';
import dayjs from 'dayjs';
import ClientCheck from '../../system/client/ClientCheck';
import ClientSelect from '../../system/client/ClientSelect';
import StateTag from '../../cpn/StateTag';
function ReportListPending(props) {
    const [form] = Form.useForm();    
    const [list, setList] = useState([]);
    const [query, setQuery] = useState({ "dsbzd_kh_id": '',});
    const [newRecordId, setNewRecordId] = useState(null);
    const [shouldOpenEdit, setShouldOpenEdit] = useState(false);
    useEffect(() => {        
        let arr = props.list.filter((item) => item.dsbzd_state === '1' && item.dsbzd_uid === props.yh_id);
        if(query.dsbzd_kh_id){
            arr = arr.filter((item) => item.dsbzd_kh_id === query.dsbzd_kh_id);
        }
        setList(arr.sort((a,b) => dayjs(b.dsbzd_ctime).diff(dayjs(a.dsbzd_ctime))));
    }, [props.list, props.yh_id, query.dsbzd_kh_id]);
    
    // 单独处理新记录打开逻辑
    useEffect(() => {
        if (newRecordId) {
            // console.log('查找新记录，ID:', newRecordId, '列表长度:', props.list.length);
            // 尝试在列表中查找新记录（支持 id 和 dsbzd_id 两种字段名）
            const newRecord = props.list.find(item => 
                item.dsbzd_id === newRecordId || item.id === newRecordId
            );
            // console.log('找到新记录:', newRecord);
            if (newRecord) {
                // 如果找到记录，立即打开
                setShouldOpenEdit(true);
            } else {
                // 如果记录不在列表中，也打开（让 ReportEdit 自己获取数据）
                // 同时设置一个延迟检查，如果列表刷新了，可以更新数据
                setShouldOpenEdit(true);
                const timer = setTimeout(() => {
                    const record = props.list.find(item => 
                        item.dsbzd_id === newRecordId || item.id === newRecordId
                    );
                    if (record) {
                        // console.log('延迟找到新记录:', record);
                        // 记录已找到，组件会自动更新
                    } else {
                        // console.log('未找到新记录，使用 ID 直接打开');
                    }
                }, 1000);
                return () => clearTimeout(timer);
            }
        }
    }, [newRecordId, props.list]);
    const columnsTable = [   
        {
            key: 'dsbzd_name',
            dataIndex: 'dsbzd_name',
            title: "团队名称",
            render: (_, record) => <ReportEdit 
                                        dsbzd_id={record.dsbzd_id} 
                                        commonList={props.commonList}
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                        dsbzd_name={record.dsbzd_name}
                                        spjdList={props.spjdList}
                                    />
        },             
       
        {
            key: 'dsbzd_date',
            dataIndex: 'dsbzd_date',
            title: "开始日期",
            width: "6%",            
        },
        {
            key: 'dsbzd_date_end',
            dataIndex: 'dsbzd_date_end',
            title: "结束日期",
            width: "6%",
        },
        {
            key: 'dsbzd_date_end',
            dataIndex: 'dsbzd_date_end',
            title: "天数",
            width: "3%",
            render: (_, record) => <>{dayjs(record.dsbzd_date_end).diff(dayjs(record.dsbzd_date), 'day') + 1}</>,
        },
      
        {
            key: 'dsbzd_kh_name',
            dataIndex: 'dsbzd_kh_name',
            title: "客户",
            width: "8%",
            render: (text, record) => <ClientCheck kh_id={record.dsbzd_kh_id} kh_name={record.dsbzd_kh_name} qy_id={props.qy_id} qy_name={props.qy_name} yh_id={props.yh_id} yh_name={props.yh_name} />
        },
        {
            key: 'dsbzd_khlxr_name',
            dataIndex: 'dsbzd_khlxr_name',
            title: "对接人",
            width: "8%",
        },
        {
            key: 'dsbzd_bm_name',
            dataIndex: 'dsbzd_bm_name',
            title: "部门",
            width: "6%",
        },        
        {
            key: 'dsbzd_jd_name',   
            dataIndex: 'dsbzd_jd_name',
            title: "计调",
            width: "6%",
        },               
        {
            key: 'dsbzd_state',
            dataIndex: 'dsbzd_state',
            title: "状态",
            width: "10%",
            render: (text, record) => <StateTag state={record.dsbzd_state} />
        },
        {
            key: 'dsbzd_id',
            dataIndex: 'dsbzd_id',
            title: "编号",
            width: "4%",            
        },
    ];

    return (
        <>   
            <Flex style={{ marginBottom: "10px" }} align='center' justify='space-between' gap={10}>
                
                <Form
                    layout='inline'
                    name='form_pending'
                    form={form}
                    initialValues={{
                        dsbzd_kh_id: undefined,
                    }}
                    onFinish={(values) => {                        
                        setQuery(prev => ({ ...prev, ...values }));
                    }}
                >
                    <ClientSelect                       
                        formStyle={{ marginBottom: "0" }}
                        onClear={() => { setQuery(prev => ({ ...prev, dsbzd_kh_id: '' })) }}
                        placeholder='请选择客户'
                        qy_id={props.qy_id}
                        style={{ width: "150px" }}
                        name='dsbzd_kh_id'
                        onChange={(e) => {}}
                        yh_id={props.yh_id}
                        list={props.commonList.kf_data}
                        wrapperCol={{ span: 24 }}
                    />                    
                    
                    <Form.Item>
                        <Space align='center' size='middle'>
                            <Icon type='search' onClick={() => {form.submit()}}/>
                            <Icon 
                                type='reset'
                                title='重置查询条件'
                                onClick={() => {
                                    form.resetFields()
                                    setQuery({"dsbzd_kh_id": '',})
                                    form.setFieldsValue({dsbzd_kh_id: undefined});
                                }}
                            />
                            
                        </Space>
                    </Form.Item>
                </Form>                   
            </Flex>
            <Table               
                dataSource={list}
                columns={columnsTable}
                className={classes.customTable}
                size='small'
                bordered
                rowKey="dsbzd_id"
                pagination={{
                    showTotal: (total) => `共${total}条`,
                    pageSize: 50,
                    placement: 'bottomCenter',
                    showSizeChanger: true,
                }}
            />
            {/* 用于新增成功后打开的 ReportEdit 实例 */}
            {shouldOpenEdit && newRecordId && (() => {
                // 从列表中查找新记录（支持 id 和 dsbzd_id 两种字段名）
                const newRecord = props.list.find(item => 
                    item.dsbzd_id === newRecordId || item.id === newRecordId
                );
                
                // 如果记录不在列表中，仍然可以打开，让 ReportEdit 自己获取数据
                if (!newRecord) {
                    // console.log('渲染时未找到新记录，使用 ID 直接打开');
                    return (
                        <ReportEdit 
                            key={newRecordId}
                            autoOpen={true}
                            onClose={() => {
                                setShouldOpenEdit(false);
                                setNewRecordId(null);
                            }}
                            dsbzd_id={newRecordId}
                            type='button'
                            qy_id={props.qy_id}
                            qy_name={props.qy_name}
                            yh_id={props.yh_id}
                            yh_name={props.yh_name}
                            commonList={props.commonList}
                            dsbzd_uid={props.yh_id}
                        />
                    );
                }
                
                // console.log('准备打开 ReportEdit，记录:', newRecord);
                return (
                    <ReportEdit 
                        key={newRecordId}
                        autoOpen={true}
                        onClose={() => {
                            // Modal 关闭时重置状态
                            setShouldOpenEdit(false);
                            setNewRecordId(null);
                        }}
                        dsbzd_id={newRecord.dsbzd_id || newRecord.id} 
                        type='button' 
                        shouru_data={newRecord.shouru_data} 
                        zhichu_data={newRecord.zhichu_data} 
                        qy_id={props.qy_id} 
                        qy_name={props.qy_name}
                        yh_id={props.yh_id}
                        dsbzd_uid={newRecord.dsbzd_uid}
                        yh_name={props.yh_name}
                        commonList={props.commonList}
                        dsbzd_date={newRecord.dsbzd_date}
                        dsbzd_date_end={newRecord.dsbzd_date_end}
                        dsbzd_month={newRecord.dsbzd_month}
                        dsbzd_year={newRecord.dsbzd_year}
                        dsbzd_kh_id={newRecord.dsbzd_kh_id}
                        dsbzd_kh_name={newRecord.dsbzd_kh_name}
                        dsbzd_jd_id={newRecord.dsbzd_jd_id}
                        dsbzd_jd_name={newRecord.dsbzd_jd_name}
                        dsbzd_zb_id={newRecord.dsbzd_zb_id}
                        dsbzd_zb_name={newRecord.dsbzd_zb_name}
                        dsbzd_dscp_id={newRecord.dsbzd_dscp_id}
                        dsbzd_dscp_name={newRecord.dsbzd_dscp_name}
                        dsbzd_dspt_id={newRecord.dsbzd_dspt_id}
                        dsbzd_dspt_name={newRecord.dsbzd_dspt_name}
                        dsbzd_content={newRecord.dsbzd_content}
                        dsbzd_danhao={newRecord.dsbzd_danhao}
                        dsbzd_uname={newRecord.dsbzd_uname}
                        dsbzd_ctime={newRecord.dsbzd_ctime}
                        dsbzd_state={newRecord.dsbzd_state}
                        dsbzd_bm_id={newRecord.dsbzd_bm_id}
                        dsbzd_bm_name={newRecord.dsbzd_bm_name}
                        dsbzd_name={newRecord.dsbzd_name}
                        dsbzd_khlxr_id={newRecord.dsbzd_khlxr_id}
                        dsbzd_khlxr_name={newRecord.dsbzd_khlxr_name}
                        dsbzd_image_file={newRecord.dsbzd_image_file}
                        dsbzd_image_name={newRecord.dsbzd_image_name}
                    />
                );
            })()}
        </>
    )
}

export default ReportListPending